import { render } from "./AddUsager.vue?vue&type=template&id=3d36eb56&scoped=true&ts=true"
import script from "./AddUsager.vue?vue&type=script&lang=ts"
export * from "./AddUsager.vue?vue&type=script&lang=ts"

import "./AddUsager.vue?vue&type=style&index=0&id=3d36eb56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d36eb56"]])

export default __exports__